import React, { useState, useEffect, useRef } from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';
import CookiesEn from './cookies/CookiesEn';
import CookiesIt from './cookies/CookiesIt';
import CookiesFr from './cookies/CookiesFr';
import CookiesEs from './cookies/CookiesEs';
import CookiesJp from './cookies/CookiesJp';
import CookiesCht from './cookies/CookiesCht';
import CookiesCn from './cookies/CookiesCn';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [modalOpen, setModalOpen] = useState(false);
  const modalCookieRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      localStorage.setItem(
        'deviceDetected',
        window.innerWidth > 1100 ? 'desktop' : 'mobile'
      );
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleCookieClick = () => {
    localStorage.setItem('cookieModal', 'open');
    setModalOpen(true);
    const languageBtn = document.getElementById('language-btn');
    if (languageBtn) {
      languageBtn.style.display = 'none';
    }
    const modalCookie = modalCookieRef.current;
    if (modalCookie) {
      modalCookie.classList.add('is-open');
      document.body.classList.add('modal-expanded', 'cookie-expanded');
    }
  };

  const closeCookieModal = () => {
    setModalOpen(false);
    const languageBtn = document.getElementById('language-btn');
    if (languageBtn) {
      languageBtn.style.display = 'block';
    }
    const modalCookie = modalCookieRef.current;
    if (modalCookie) {
      modalCookie.classList.remove('is-open');
      document.body.classList.remove('modal-expanded', 'cookie-expanded');
    }
    localStorage.setItem('cookieModal', 'close');
  };

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const openCookieCta = document.querySelectorAll('.cookie-cta');

    const eventHandler = (e) => {
      e.preventDefault();
      handleCookieClick();
    };

    openCookieCta.forEach((button) => {
      button.addEventListener(isTouchDevice ? 'touchstart' : 'click', eventHandler);
    });

    return () => {
      openCookieCta.forEach((button) => {
        button.removeEventListener(isTouchDevice ? 'touchstart' : 'click', eventHandler);
      });
    };
  }, []);

  return (
    <div className="footer-container">
      <footer className="wrap-footer">
        <div className="footer">
          <button
            className="footer__link cookie-cta"
            onClick={handleCookieClick}
          >
            {t('COOKIE_POLICY_LABEL')}
          </button>
        </div>
      </footer>
      <div
        className="modal modal--cookie"
        id="cookie"
        ref={modalCookieRef}
        aria-hidden={!modalOpen}
      >
        <div className="modal-page">
          <button
            className="lang-close-model"
            type="button"
            aria-label="Close"
            onClick={closeCookieModal}>
            ×
          </button>
          <h2>{t('COOKIE_POLICY_LABEL')}</h2>
          {currentLanguage === 'en' && <CookiesEn />}
          {currentLanguage === 'it' && <CookiesIt />}
          {currentLanguage === 'fr' && <CookiesFr />}
          {currentLanguage === 'es' && <CookiesEs />}
          {currentLanguage === 'jp' && <CookiesJp />}
          {currentLanguage === 'cht' && <CookiesCht />}
          {currentLanguage === 'chs' && <CookiesCn />}
        </div>
      </div>
      <div className="overflow-bg" onClick={closeCookieModal}></div>
    </div>
  );
};

export default Footer;





